import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux';
import { MenuOutlined } from '@ant-design/icons';
import { Layout } from 'antd';
import { isChrome } from '../../services/helper/browser';
import { clearCCCStatus } from '../CCC/store/action';
import { changeLeft, changeTop } from "../panelStore/action";
import { closeTabFooter, openTabFooter, cleanTabMonitorStatus } from '../MonitorStore/action';
import Line from '@/components/Line';
import CascadeSider from './CascadeSider';
import { CASCADE } from '../../constants/pageType';
import CascadeContent from './Content'
import { setPageType } from '../Login/action';
import SideFooter from '@/components/SideFooter';
import { updatePageLayout, updatePCBLayout } from './store/project/action';
import { SINGLE_PAGE_LAYOUT } from '../../constants/layoutConstants';
import { changeProduct } from '../LayoutExplorer/LayoutStore/action';
import '@/publicCss/style.css';
import '@/publicCss/tree.css';
import '@/publicCss/libraryStyle.css';
import '@/publicCss/aurora.css';
import '@/publicCss/auroraContent.css';
import './cascade.css';

const { Content } = Layout
class CascadePage extends Component {
  constructor(props) {
    super(props);
    this.version = props.version;
    this.servicesAccount = props.servicesAccount;
    this.state = {
      width: 280,
      linePosition: {
        position: "absolute",
        left: 280
      },
      openMenu: true,
      chrome: true,
      browserVisible: false
    }
  }
  componentWillMount() {
    //clear CCC status
    this.props._clearCCCStatus();

    this.props.setPageType(CASCADE);
  }

  changeWidth(width) {
    let position = {
      position: "absolute",
      left: width,
      minWidth: 56,
      maxWidth: 1000
    }
    this.setState({
      linePosition: position,
      width
    })
    //page left sider
    this.props._changeLeft(width);
  }

  componentDidMount = () => {
    this.props.changeProduct(CASCADE);
    //page left sider
    this.props._changeLeft(280);
    //page top menu
    this.props._changeTop(54);
    //clear monitor reducer
    this.props._cleanTabMonitorStatus();
    const chrome = isChrome();
    this.setState({
      chrome,
      browserVisible: chrome ? false : true
    })
  }

  componentDidUpdate = (prevProps) => {
    const { pageType } = this.props;
    if (pageType !== prevProps.pageType) {
      //switch product, clear monitor reducer
      this.props._cleanTabMonitorStatus();
    }
  }

  changeSize = (width) => {
    let newWidth = width;
    const prevWidth = this.state.width;
    if (prevWidth === 56 && width > 56) {
      this.setState({
        openMenu: true
      });
      newWidth = 255;
      this.changeWidth(newWidth);
    } else {
      width = width < 255 ? 56 : width;
      width = width > 1000 ? 1000 : width;
      if (width === 56) {
        this.setState({
          openMenu: false
        });
      }
      this.changeWidth(width);
    }
  }

  openMenu = (e) => {
    e && e.stopPropagation();
    this.setState({
      openMenu: true,
      width: 255,
      linePosition: {
        position: "absolute",
        left: 255,
        minWidth: 56,
        maxWidth: 1000,
      }
    });
  }

  layoutClick = (layoutType, singleType) => {
    if (singleType) {
      this.viewClick(singleType);
      return;
    }
    this.props._updatePageLayout(layoutType);
  }

  viewClick = (type) => {
    this.props._updatePageLayout(SINGLE_PAGE_LAYOUT, type);
  }

  changeTabFooter = () => {
    const { _openTabFooter, _closeTabFooter, tabVisible } = this.props;
    tabVisible ? _closeTabFooter() : _openTabFooter();
  }

  render = () => {
    const { width, chrome, openMenu, linePosition } = this.state
    return (
      <Fragment>
        {chrome ? <Layout className="aurora-layout">
          <div className="aurora-sider" style={{ width: width }}>
            {openMenu ?
              <div className="cascade-sider-menu-tree aurora-sider-menu-tree">
                <CascadeSider siderWidth={width} />
              </div>
              :
              <div className='aurora-sider-menu'>
                <MenuOutlined onClick={(e) => this.openMenu(e)} />
              </div>
            }
            <SideFooter
              actions={this.sideFooterActions()}
            />
          </div>
          <Line
            position={linePosition}
            changeWidth={(width) => this.changeWidth(width)}
            width={width}
            resize={this.changeSize}
          />
          <Content className='aurora-content cascade-content' style={{ left: width, overflow: '' }}>
            <CascadeContent
              siderWidth={width}
              version={this.version}
              servicesAccount={this.servicesAccount}
              openMenu={this.openMenu}
            />
          </Content>
        </Layout> : null
        }
      </Fragment>
    );
  }

  pcbLayoutChange = (type) => {
    const { pcbLayout } = this.props;
    this.props._updatePCBLayout(type, pcbLayout);
  }

  sideFooterActions = () => {
    const { openMenu } = this.state;
    const { viewList, tabVisible, layout, openProjectId, pcbLayout } = this.props;
    return {
      openMenu,
      viewList,
      tabVisible,
      layout,
      pcbLayout,
      currentProjectId: openProjectId,
      pcbLayoutChange: this.pcbLayoutChange,
      layoutClick: this.layoutClick,
      changeTabFooter: this.changeTabFooter
    }
  }
}

const mapState = (state) => {
  const { PanelStatus, LoginReducer: { pageType }, CascadeReducer } = state;
  const { defaultTop, defaultLeft } = PanelStatus;
  const { tabVisible } = state.MonitorInfoReducer;
  const { project: { openProjectId, viewList, layout, pcbLayout } } = CascadeReducer;
  return {
    pageType,
    defaultTop,
    defaultLeft,
    tabVisible,
    openProjectId,
    viewList,
    layout,
    pcbLayout
  }
}
const mapDispatch = (dispatch) => ({
  _clearCCCStatus() {
    dispatch(clearCCCStatus());
  },
  _changeLeft(width) {
    dispatch(changeLeft(width));
  },
  _changeTop(top) {
    dispatch(changeTop(top));
  },
  _cleanTabMonitorStatus() {
    dispatch(cleanTabMonitorStatus());
  },
  _openTabFooter() {
    dispatch(openTabFooter())
  },
  _closeTabFooter() {
    dispatch(closeTabFooter())
  },
  setPageType(type) {
    dispatch(setPageType(type))
  },
  _updatePageLayout(layout, singleType) {
    dispatch(updatePageLayout(layout, singleType))
  },
  _updatePCBLayout(pcbLayout, prePcbLayout) {
    dispatch(updatePCBLayout(pcbLayout, prePcbLayout))
  },
  changeProduct(product) {
    dispatch(changeProduct(product))
  }
})

export default connect(mapState, mapDispatch)(CascadePage)